import React, { useState } from 'react';
import { motion } from 'framer-motion';

const CelebrityShoutouts = () => {
  const celebrities = [
    { id: 1, color: 'bg-neutral-800', isOffset: false },
    { id: 2, color: 'bg-neutral-700', isOffset: true },
    { id: 3, color: 'bg-neutral-800', isOffset: false },
    { id: 4, color: 'bg-neutral-700', isOffset: true },
    { id: 5, color: 'bg-neutral-800', isOffset: false },
    { id: 6, color: 'bg-neutral-700', isOffset: true },
    { id: 7, color: 'bg-neutral-800', isOffset: false },
    { id: 8, color: 'bg-neutral-700', isOffset: true },
    { id: 9, color: 'bg-neutral-800', isOffset: false },
    { id: 10, color: 'bg-neutral-700', isOffset: true }
  ];

  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section className="w-full bg-black py-16 pb-8 -mt-4">
      <div className="container mx-auto px-4">
        <div className="hidden lg:grid grid-cols-10 gap-3 max-w-7xl mx-auto">
          {celebrities.map((celebrity) => (
            <div 
              key={celebrity.id} 
              className={`relative aspect-[2/5] ${celebrity.isOffset ? 'mt-16' : '-mt-8'}`}
            >
              <motion.div
                className={`absolute inset-0 rounded-sm cursor-pointer ${celebrity.color} overflow-hidden`}
                initial={{ width: '100%' }}
                // whileHover={{ 
                //   width: '180%', 
                //   zIndex: 50,
                //   x: '-22.5%' // Centers the expanded card
                // }}
                animate={{
                  width: hoveredId !== null ? (hoveredId === celebrity.id ? '140%' : '80%') : '100%',
                  // zIndex: hoveredId !== null && hoveredId === celebrity.id ? 50 : 0,
                  x: hoveredId !== null && hoveredId === celebrity.id ? '-22.5%' : 0
                }}
                transition={{ 
                  duration: 0.5, 
                  ease: "easeOut"
                }}
                onMouseEnter={() => setHoveredId(celebrity.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/50 transition-all duration-500 group-hover:bg-black/40"></div>
                <motion.div 
                  className="absolute inset-0"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.7 }}
                />
                <motion.div 
                  className="absolute bottom-0 left-0 right-0 p-3"
                  whileHover={{ y: -2 }}
                  transition={{ duration: 0.5 }}
                >
                  <motion.div 
                    className="h-1 bg-white/30 rounded-full" 
                    initial={{ width: '50%' }}
                    whileHover={{ width: '75%', backgroundColor: 'rgba(255,255,255,0.5)' }}
                    transition={{ duration: 0.5 }}
                  />
                </motion.div>
              </motion.div>
            </div>
          ))}
        </div>

        {/* Mobile View */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:hidden gap-3 max-w-7xl mx-auto">
          {celebrities.slice(0, 6).map((celebrity, index) => (
            <div 
              key={celebrity.id} 
              className={`relative aspect-[2/5] ${index % 2 === 0 ? 'mt-8' : '-mt-8'}`}
            >
              <motion.div
                className={`absolute inset-0 rounded-sm cursor-pointer ${celebrity.color} overflow-hidden`}
                initial={{ width: '100%' }}
                whileHover={{ 
                  width: '140%', 
                  zIndex: 50,
                  x: '-17%' // Centers the expanded card
                }}
                transition={{ 
                  duration: 0.5, 
                  ease: "easeOut"
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/50 transition-all duration-500 group-hover:bg-black/40"></div>
                <motion.div 
                  className="absolute inset-0"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.7 }}
                />
                <motion.div 
                  className="absolute bottom-0 left-0 right-0 p-3"
                  whileHover={{ y: -2 }}
                  transition={{ duration: 0.5 }}
                >
                  <motion.div 
                    className="h-1 bg-white/30 rounded-full" 
                    initial={{ width: '50%' }}
                    whileHover={{ width: '75%', backgroundColor: 'rgba(255,255,255,0.5)' }}
                    transition={{ duration: 0.5 }}
                  />
                </motion.div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CelebrityShoutouts; 